import React from "react";
import {Button, ButtonGroup, FormItem, Input, SimpleCell, Switch} from "@vkontakte/vkui";
import BaseComponent from "../../components/BaseComponent";
import StandCollectionsApi from "../../api/references/standcollections";

/**
 * Короткая форма коллекции внутри модалки карточки стенда.
 * Свой PanelHeader не рисует: заголовок задаёт ModalPage снаружи.
 * props: collection ({id, title, deleted} или пусто), existingTitles, isOffline, onSaved(data), onCancel()
 */
class StandCollectionQuickForm extends BaseComponent {

    constructor(props) {
        super(props)
        const collection = props.collection || {}
        this.state = {
            ...this.state,
            title: collection.title || '',
            deleted: Number(collection.deleted) === 1 ? 1 : 0,
            saving: false,
        }
    }

    isDuplicate = (title) => {
        const ownTitle = String((this.props.collection && this.props.collection.title) || '').trim().toLowerCase()
        const next = title.toLowerCase()
        let skippedOwn = false
        return (this.props.existingTitles || []).some(item => {
            const current = String(item || '').trim().toLowerCase()
            if (!skippedOwn && ownTitle && current === ownTitle) {
                skippedOwn = true
                return false
            }
            return current === next
        })
    }

    save = async () => {
        if (this.props.isOffline) {
            this.openErrorNoty('В режиме offline нельзя менять коллекции')
            return
        }
        const title = this.state.title.trim()
        if (!title) {
            this.openErrorNoty('Укажите наименование коллекции')
            return
        }
        if (this.isDuplicate(title)) {
            this.openErrorNoty('Коллекция с таким названием уже есть')
            return
        }

        const id = this.props.collection && this.props.collection.id > 0 ? this.props.collection.id : 0
        this.setState({saving: true})
        try {
            const result = await StandCollectionsApi.save({
                id,
                title,
                deleted: id > 0 ? this.state.deleted : 0,
            })
            this.setState({saving: false})
            if (result.data && result.data.id) {
                window.postMessage({type: 'success', text: 'Коллекция сохранена', timeout: 1500, hideSpinner: true})
                window.postMessage({type: 'standCollectionsChanged'})
                if (this.props.onSaved) this.props.onSaved(result.data)
            } else {
                this.openErrorNoty('Не удалось сохранить коллекцию')
            }
        } catch (e) {
            this.setState({saving: false})
            this.openErrorNoty('Не удалось сохранить коллекцию')
        }
    }

    render() {
        const isEdit = this.props.collection && this.props.collection.id > 0
        return <div className="stand-kit-form">
            <div className="stand-kit-form__body">
                <FormItem top="Наименование">
                    <Input value={this.state.title} onChange={e => this.setState({title: e.target.value})}/>
                </FormItem>
                {isEdit && <FormItem>
                    <SimpleCell Component="label" multiline
                                after={<Switch checked={!!this.state.deleted}
                                               onChange={e => this.setState({deleted: e.target.checked ? 1 : 0})}/>}>
                        Запрет ввода
                    </SimpleCell>
                </FormItem>}
            </div>
            <div className="stand-kit-form__actions">
                <ButtonGroup mode="horizontal" stretched>
                    <Button stretched size="l" mode="secondary" disabled={this.state.saving}
                            onClick={this.props.onCancel}>Отмена</Button>
                    <Button stretched size="l" disabled={this.state.saving} onClick={this.save}>Сохранить</Button>
                </ButtonGroup>
            </div>
        </div>
    }
}

export default StandCollectionQuickForm
